import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getExcludedAssetTypes } from '../../thunks/cycle_count_excluded_asset_types_thunks';
import { withUserType } from '../withUserType';
import ExcludedAssetTypesModal from './ExcludedAssetTypesModal';

interface ExcludedAssetTypesButtonProps {
	userType: string;
	fetchExcludedAssetTypes: () => Promise<any>;
}

const ExcludedAssetTypesButton: FC<ExcludedAssetTypesButtonProps> = ({
	fetchExcludedAssetTypes,
}) => {
	const [modalVisible, setModalVisible] = useState(false);
	const [count, setCount] = useState(0);
	const [loading, setLoading] = useState(false);

	const fetchCount = useCallback(() => {
		setLoading(true);
		fetchExcludedAssetTypes()
			.then((data) => {
				const excluded = nullSafeGetOrElse('excludedAssetTypeIds', data, []);
				setCount(excluded.length);
			})
			.catch(() => {
				setCount(0);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [fetchExcludedAssetTypes]);

	useEffect(() => {
		fetchCount();
	}, [fetchCount]);

	const handleOpen = useCallback(() => {
		setModalVisible(true);
	}, []);

	const handleClose = useCallback(() => {
		setModalVisible(false);
		fetchCount();
	}, [fetchCount]);

	return (
		<>
			<Button size="large" loading={loading} onClick={handleOpen}>
				{'Excluded Asset Types (' + count + ')'}
			</Button>
			<ExcludedAssetTypesModal visible={modalVisible} onClose={handleClose} />
		</>
	);
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchExcludedAssetTypes: () => dispatch(getExcludedAssetTypes(ownProps.userType)),
});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(ExcludedAssetTypesButton));
